import axiosClient from "./axiosClient";

const electrocardiographyService = {
  getLitElectrocardiography: async (params) => {
    const url = "/qlkhambenh/phieu-dien-tim/danh-sach-phieu-dien-tim";
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getDetailsElectrocardiographyById: async (id) => {
    const url = `/qlkhambenh/phieu-dien-tim/chi-tiet-dien-tim?idPhieuDienTim=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  updateDetails: async (data) => {
    const params = { id: data?.id };
    const url = `/qlkhambenh/phieu-dien-tim`;
    const response = await axiosClient.put(url, data, { params: params });
    return response.data;
  },
  updateStatusElectrocardiography: async (params) => {
    const url = `/qlkhambenh/phieu-dien-tim/cap-nhat-trang-thai`;
    const response = await axiosClient.put(url, {}, { params: params });
    return response.data;
  },
  nextPatientById: async () => {
    const url = `/qlkhambenh/phieu-dien-tim/benh-nhan-tiep-theo`;
    const response = await axiosClient.get(url);
    return response;
  },
  //danh mục
  getLisElectroCardiographyCatalog: async () => {
    const url = `/qlkhambenh/dm-mau-dien-tim/list-dm-mau-dien-tim`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postLisElectoCardiographyCatalog: async (data) => {
    const url = `/qlkhambenh/dm-mau-dien-tim`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateLisElectoCardiographyCatalog: async (data) => {
    const url = `/qlkhambenh/dm-mau-dien-tim?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteLisElectoCardiographyCatalog: async (id) => {
    const url = `/qlkhambenh/dm-mau-dien-tim?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },

  //print
  getDetailPrintElectro: async (id) => {
    const url = `/qlkhambenh/phieu-dien-tim-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
};

export default electrocardiographyService;
